// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/notification.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.Notification
 */
export const Notification = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Notification",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_read", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListNotificationsRequest
 */
export const ListNotificationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListNotificationsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "unread_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListNotificationsResponse
 */
export const ListNotificationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListNotificationsResponse",
  () => [
    { no: 1, name: "notifications", kind: "message", T: Notification, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.MarkReadRequest
 */
export const MarkReadRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MarkReadRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.MarkReadResponse
 */
export const MarkReadResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MarkReadResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.MarkAllReadRequest
 */
export const MarkAllReadRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MarkAllReadRequest",
  [],
);

/**
 * @generated from message omnios.v1.MarkAllReadResponse
 */
export const MarkAllReadResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MarkAllReadResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetUnreadCountRequest
 */
export const GetUnreadCountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetUnreadCountRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetUnreadCountResponse
 */
export const GetUnreadCountResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetUnreadCountResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDeviceRequest
 */
export const RegisterDeviceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDeviceRequest",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDeviceResponse
 */
export const RegisterDeviceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDeviceResponse",
  [],
);

/**
 * @generated from message omnios.v1.UnregisterDeviceRequest
 */
export const UnregisterDeviceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnregisterDeviceRequest",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UnregisterDeviceResponse
 */
export const UnregisterDeviceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnregisterDeviceResponse",
  [],
);

/**
 * @generated from message omnios.v1.NotificationPreference
 */
export const NotificationPreference = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.NotificationPreference",
  () => [
    { no: 1, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPreferencesRequest
 */
export const GetPreferencesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPreferencesRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetPreferencesResponse
 */
export const GetPreferencesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPreferencesResponse",
  () => [
    { no: 1, name: "preferences", kind: "message", T: NotificationPreference, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePreferenceRequest
 */
export const UpdatePreferenceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePreferenceRequest",
  () => [
    { no: 1, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePreferenceResponse
 */
export const UpdatePreferenceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePreferenceResponse",
  [],
);

/**
 * @generated from message omnios.v1.EventTypeInfo
 */
export const EventTypeInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EventTypeInfo",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "channels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEventTypesRequest
 */
export const ListEventTypesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEventTypesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListEventTypesResponse
 */
export const ListEventTypesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEventTypesResponse",
  () => [
    { no: 1, name: "event_types", kind: "message", T: EventTypeInfo, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.WebhookSubscription
 */
export const WebhookSubscription = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WebhookSubscription",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "events", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "headers", kind: "message", T: Struct },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateWebhookRequest
 */
export const CreateWebhookRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateWebhookRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "events", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "headers", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateWebhookRequest
 */
export const UpdateWebhookRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateWebhookRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "events", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "headers", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteWebhookRequest
 */
export const DeleteWebhookRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteWebhookRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWebhooksRequest
 */
export const ListWebhooksRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhooksRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListWebhooksResponse
 */
export const ListWebhooksResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhooksResponse",
  () => [
    { no: 1, name: "webhooks", kind: "message", T: WebhookSubscription, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.TestWebhookRequest
 */
export const TestWebhookRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TestWebhookRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.TestWebhookResponse
 */
export const TestWebhookResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TestWebhookResponse",
  () => [
    { no: 1, name: "response_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "response_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.WebhookDelivery
 */
export const WebhookDelivery = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WebhookDelivery",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "response_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attempt", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListWebhookDeliveriesRequest
 */
export const ListWebhookDeliveriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhookDeliveriesRequest",
  () => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWebhookDeliveriesResponse
 */
export const ListWebhookDeliveriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhookDeliveriesResponse",
  () => [
    { no: 1, name: "deliveries", kind: "message", T: WebhookDelivery, repeated: true },
  ],
);

/**
 * Enumerate all available event types for webhook configuration
 *
 * @generated from message omnios.v1.ListWebhookEventTypesRequest
 */
export const ListWebhookEventTypesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhookEventTypesRequest",
  [],
);

/**
 * @generated from message omnios.v1.WebhookEventType
 */
export const WebhookEventType = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WebhookEventType",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWebhookEventTypesResponse
 */
export const ListWebhookEventTypesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWebhookEventTypesResponse",
  () => [
    { no: 1, name: "event_types", kind: "message", T: WebhookEventType, repeated: true },
  ],
);

